module.exports = __webpack_public_path__ + "img/latvia.4fd871ca.svg";